import { lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { useAuth } from '../modules/auth';
import { Service } from '../pages/users/detail/sections/Permission';

const PrivateRoutes = () => {
  // Icon will be navigate to alert list if no permission
  const { currentUser, logout } = useAuth()
  const serviceDefaultRoutes: Record<Service, string> = {
    ETHOCA: '/ethoca/alerts/list',
    RDR: '/rdr/cases/list',
    BECEIPT: '/beceipt/transactions/list',
    OI: '/oi/lookups/list',
    SI: '/si/brand/form',
    SHUFTIPRO: '/aml/individual-screening/list',
    SITE_INTELLIGENCE: '/site-inspect/reports/list',
    STATISTICS: undefined,
    TLD: '/tld/sites/list',
    CDRN: '/cdrn/cases/list',
  }
  const registeredServices = Array.isArray(currentUser?.registered_service)
    ? currentUser.registered_service
    : []
  const defaultRouteByRegisteredService = registeredServices
    .map((service) => serviceDefaultRoutes[service])
    .find(Boolean)
  const defaultHomeRoute = defaultRouteByRegisteredService ? defaultRouteByRegisteredService : '/ethoca/alerts/list'

  const AlertsList = lazy(() => import('../pages/ethoca/alerts/list/List'));
  const UploadStatus = lazy(() => import('../pages/ethoca/alerts/upload-status/list/List'));
  const AlertsDetail = lazy(() => import('../pages/ethoca/alerts/detail/Detail'));
  const DescriptorList = lazy(() => import('../pages/ethoca/descriptors/list/List'));
  const ClientList = lazy(() => import('../pages/ethoca/client/list/List'));
  // const ClientTree = lazy(() => import('../pages/ethoca/client/tree/Tree'))
  const ClientDetail = lazy(() => import('../pages/ethoca/client/detail/Detail'));
  const EnquiriesList = lazy(() => import('../pages/ethoca/enquiries/list/Lists'))
  const EnquiriesCreateForm = lazy(() => import('../pages/ethoca/enquiries/form/EnquiriesCreateForm'))
  const CreditList = lazy(() => import('../pages/ethoca/credit/list/Lists'))
  // const AuditLogsList = lazy(() => import('../pages/ethoca/auditLogs/list/List'))

  const RdrCasesList = lazy(() => import('../pages/verifi/cases/list/List'));
  const RdrClientList = lazy(() => import('../pages/verifi/client/list/List'));
  const RdrCaidList = lazy(() => import('../pages/verifi/caid/list/List'));
  const RdrCaidCreateForm = lazy(() => import('../pages/verifi/caid/form/CaidCreateForm'));

  /* Beceipt routes */
  const TransactionsList = lazy(() => import('../pages/beceipt/transactions/list/List'));
  const TransactionsDetail = lazy(() => import('../pages/beceipt/transactions/detail/Detail'));
  const BeceiptRequestsList = lazy(() => import('../pages/beceipt/request/list/List'));
  // const BeceiptFailedEmailsList = lazy(() => import('../pages/beceipt/emails/list/List'));
  // const BeceiptClientList = lazy(() => import('../pages/beceipt/client/list/List'))

  /* OI routes */
  const LookUpList = lazy(() => import('../pages/oi/lookup/list/List'));
  const LookupDetail = lazy(() => import('../pages/oi/lookup/detail/Detail'));
  const OiCaidList = lazy(() => import('../pages/oi/caid/list/List'));
  const OiCaidCreateForm = lazy(() => import('../pages/oi/caid/form/CaidCreateForm'))

  /* Shufti Pro routes */
  const AmlIndividualEnquiriesList = lazy(() => import('../pages/shuftiPro/amlIndividual/list/List'))
  const AmlIndividualEnquiriesDetail = lazy(() => import('../pages/shuftiPro/amlIndividual/detail/Detail'))
  const AmlBusinessEnquiriesList = lazy(() => import('../pages/shuftiPro/amlBusiness/list/List'))
  const AmlBusinessEnquiriesDetail = lazy(() => import('../pages/shuftiPro/amlBusiness/detail/Detail'))
  const ShuftiClientList = lazy(() => import('../pages/shuftiPro/client/list/List'))
  const ShuftiClientDetail = lazy(() => import('../pages/shuftiPro/client/detail/Detail'))
  const DocumentVerificationList = lazy(() => import('../pages/shuftiPro/documentVerification/list/List'))
  const DocumentVerificationDetail = lazy(() => import('../pages/shuftiPro/documentVerification/detail/Detail'))

  /* User routes */
  // const UsersList = lazy(() => import('../pages/users/list/List'))
  // const UsersDetail = lazy(() => import('../pages/users/detail/Detail'))

  /* Monitor routes */
  // const DuplicateList = lazy(() => import('../pages/monitor/duplicate/list/List'))
  // const EthocaDuplicateList = lazy(() => import('../pages/monitor/ethocaDuplicate/list/List'))
  // const EthocaDuplicateDetail = lazy(() => import('../pages/monitor/ethocaDuplicate/detail/Detail'))

  // Settlement routes
  // const SettlementDuplicateList = lazy(() => import('../pages/settlement/duplicateArn/list/List'))
  // const RdrRecallList = lazy(() => import('../pages/settlement/rdrRecalledCase/list/List'))
  // const SettlementClientList = lazy(() => import('../pages/settlement/client/list/List'))

  // TLD Log routes
  // const TldLogClientList = lazy(() => import('../pages/tldLog/client/list/List'))
  // const TldLogClientDetail = lazy(() => import('../pages/tldLog/client/detail/Detail'))

  // SI routes
  const SiAddBrandForm = lazy(() => import('../pages/siteInspect/brand/form/BrandAddForm'))

  // Site Intelligence routes
  // const SiteList = lazy(() => import('../pages/siteIntelligence/site/list/List'));
  const SiList = lazy(() => import('../pages/siteIntelligence/si/list/List'));
  const SiBySiteList = lazy(() => import('../pages/siteIntelligence/si/list/BySiteList'));
  const RemarkOptionList = lazy(() => import('../pages/siteIntelligence/remarkOption/list/List'));
  const SiReviewList = lazy(() => import('../pages/siteIntelligence/review/list/List'));
  const SiReviewHistoryList = lazy(() => import('../pages/siteIntelligence/reviewHistory/list/List'));
  // const KeywordExtractionList = lazy(() => import('../pages/siteIntelligence/keywordExtraction/list/List'));
  // const KeywordList = lazy(() => import('../pages/siteIntelligence/keyword/list/List'));
  // const BrandList = lazy(() => import('../pages/siteIntelligence/brand/list/List'));
  const ScheduleList = lazy(() => import('../pages/siteIntelligence/schedule/list/List'));
  const ScheduleCreateForm = lazy(() => import('../pages/siteIntelligence/schedule/form/ScheduleCreateForm'));
  const SiClientList = lazy(() => import('../pages/siteIntelligence/client/list/List'));
  const SiClientDetail = lazy(() => import('../pages/siteIntelligence/client/detail/Detail'));

  // const DomainInfoDetail = lazy(() => import('../pages/siteIntelligence/site/detail/DomainInfoDetail'));
  // const WebContentDetail = lazy(() => import('../pages/siteIntelligence/site/detail/WebContentDetail'));
  // const SexualContentDetail = lazy(() => import('../pages/siteIntelligence/site/detail/SexualContentDetail'));
  // const TobaccoContentDetail = lazy(() => import('../pages/siteIntelligence/site/detail/TobaccoContentDetail'));
  // const HighRiskIpDetail = lazy(() => import('../pages/siteIntelligence/site/detail/HighRiskIpDetail'));
  // const DisposableEmailDetail = lazy(() => import('../pages/siteIntelligence/site/detail/DisposableEmailDetail'));
  // const InboundFlowDetail = lazy(() => import('../pages/siteIntelligence/site/detail/InboundFlowDetail'));
  // const OutBoundFlowDetail = lazy(() => import('../pages/siteIntelligence/site/detail/OutboundFlowDetail'));
  // const SocialMediaFlowDetail = lazy(() => import('../pages/siteIntelligence/site/detail/SocialMediaFlowDetail'));
  // const CustomerDisputeDetail = lazy(() => import('../pages/siteIntelligence/site/detail/CustomerDisputeDetail'));
  // const BrandDetectionDetail = lazy(() => import('../pages/siteIntelligence/site/detail/BrandDetectionDetail'));
  // const RelatedIdentityDetail = lazy(() => import('../pages/siteIntelligence/site/detail/RelatedIdentityDetail'));
  // const MembersOnlyDetail = lazy(() => import('../pages/siteIntelligence/site/detail/MembersOnlyDetail'));
  // const CategoryDetail = lazy(() => import('../pages/siteIntelligence/site/detail/CategoryDetail'));
  const SiDetail = lazy(() => import('../pages/siteIntelligence/si/detail/Detail'));

  const TldSitesList = lazy(() => import('../pages/tld/sites/list/List'));
  const TldSitesCreateForm = lazy(() => import('../pages/tld/sites/form/SitesCreateForm'));
  const TldSitesDeleteForm = lazy(() => import('../pages/tld/sites/form/SitesDeleteForm'));
  const TldReportsList = lazy(() => import('../pages/tld/reports/list/List'));
  // const TldTransactionsList = lazy(() => import('../pages/tld/transactions/list/List'));
  // const TldTransactionsDetail = lazy(() => import('../pages/tld/transactions/detail/Detail'));
  // const TldClientList = lazy(() => import('../pages/tld/client/list/List'));
  // const TldClientDetail = lazy(() => import('../pages/tld/client/detail/Detail'));
  // const TldQuotasList = lazy(() => import('../pages/tld/quotas/list/List'));
  // const TldRemarkOptionsList = lazy(() => import('../pages/tld/remarkOptions/list/List'));
  // const TldReviewsList = lazy(() => import('../pages/tld/reviews/list/List'));
  // const TldReviewReportsList = lazy(() => import('../pages/tld/reviewReports/list/List'));
  // const TldAuditLogsList = lazy(() => import('../pages/tld/auditLogs/list/List'));

  const CdrnClientList = lazy(() => import('../pages/cdrn/client/list/List'));
  const CdrnClientDetail = lazy(() => import('../pages/cdrn/client/detail/Detail'));
  const CdrnDescriptorList = lazy(() => import('../pages/cdrn/descriptors/list/List'));
  const CdrnCaseList = lazy(() => import('../pages/cdrn/case/list/List'));
  const CdrnCaseDetail = lazy(() => import('../pages/cdrn/case/detail/Detail'));

  const ContactUs = lazy(() => import('../pages/contactUs/ContactUs'));

  // const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        {/* <Route path='auth/*' element={<Navigate to={haveDashBoardPermission ? '/dashboard' : '/ethoca/alerts/list'} />} /> */}
        <Route path='auth/*' element={<Navigate to={defaultHomeRoute} />} />

        {/* Redirect to Dashboard on root route */}
        {/* <Route path='' element={<Navigate to={haveDashBoardPermission ? '/dashboard' : '/ethoca/alerts/list'} />} /> */}
        <Route path='' element={<Navigate to={defaultHomeRoute} />} />

        {/* Pages */}
        {/* Ethoca */}
        <Route path='ethoca/alerts/list' element={<AlertsList />} />
        <Route path='ethoca/alerts/upload-status/list' element={<UploadStatus />} />
        <Route path='ethoca/alerts/:id' element={<AlertsDetail />} />
        <Route path='ethoca/descriptors/list' element={<DescriptorList />} />
        <Route path='ethoca/clients/list' element={<ClientList />} />
        {/* <Route path='ethoca/clients/tree' element={<ClientTree />} /> */}
        <Route path='ethoca/clients/:id' element={<ClientDetail />} />
        <Route path='ethoca/enquiries/list' element={<EnquiriesList />} />
        <Route path='ethoca/enquiries/form' element={<EnquiriesCreateForm />} />
        <Route path='ethoca/credits/list' element={<CreditList />} />
        {/* <Route path='ethoca/audit-logs/list' element={<AuditLogsList />} /> */}

        {/* Rdr */}
        <Route path='rdr/cases/list' element={<RdrCasesList />} />
        <Route path='rdr/clients/list' element={<RdrClientList />} />
        <Route path='rdr/caids/list' element={<RdrCaidList />} />
        <Route path='rdr/caids/form' element={<RdrCaidCreateForm />} />

        {/* Beceipt */}
        <Route path='beceipt/transactions/list' element={<TransactionsList />} />
        <Route path='beceipt/transactions/:id' element={<TransactionsDetail />} />
        <Route path='beceipt/requests/list' element={<BeceiptRequestsList />} />
        {/* <Route path='beceipt/failed-emails/list' element={<BeceiptFailedEmailsList />} /> */}
        {/* <Route path='beceipt/clients/list' element={<BeceiptClientList />} /> */}

        {/* OI */}
        <Route path='oi/lookups/list' element={<LookUpList />} />
        <Route path='oi/lookups/:id' element={<LookupDetail />} />
        <Route path='oi/caids/list' element={<OiCaidList />} />
        <Route path='oi/caids/form' element={<OiCaidCreateForm />} />

        {/* Shufti Pro */}
        <Route path='aml/individual-screening/list' element={<AmlIndividualEnquiriesList />} />
        <Route path='aml/individual-screening/:id' element={<AmlIndividualEnquiriesDetail />} />
        <Route path='aml/business-screening/list' element={<AmlBusinessEnquiriesList />} />
        <Route path='aml/business-screening/:id' element={<AmlBusinessEnquiriesDetail />} />
        <Route path='aml/clients/list' element={<ShuftiClientList />} />
        <Route path='aml/clients/:id' element={<ShuftiClientDetail />} />
        <Route path='aml/document-verification/list' element={<DocumentVerificationList />} />
        <Route path='aml/document-verification/:id' element={<DocumentVerificationDetail />} />

        {/* User */}
        {/* <Route path='users/list' element={<UsersList />} /> */}
        {/* <Route path='users/:name' element={<UsersDetail />} /> */}

        {/* Monitor */}
        {/* <Route path='monitor/duplicate/list' element={<DuplicateList />} />
        <Route path='monitor/duplicate-ethoca/list' element={<EthocaDuplicateList />} />
        <Route path='monitor/duplicate-ethoca/:arn' element={<EthocaDuplicateDetail />} />
        <Route path='monitor/recall-rdr/list' element={<RdrRecallList />} /> */}

        {/* Settlement */}
        {/* <Route path='settlement/duplicate-arn/list' element={<SettlementDuplicateList />} />
        <Route path='settlement/recall-rdr/list' element={<RdrRecallList />} />
        <Route path='settlement/clients/list' element={<SettlementClientList />} />
        <Route path='settlement/clients/:id' element={<SettlementClientDetail />} /> */}

        {/* TLD Log */}
        {/* <Route path='tld-log/clients/list' element={<TldLogClientList />} />
        <Route path='tld-log/clients/:merchant_id' element={<TldLogClientDetail />} /> */}

        {/* SiteInspect */}
        <Route path='si/brand/form' element={<SiAddBrandForm />} />

        {/* SiteIntelligence */}
        {/* <Route path='site-intelligence/sites/list' element={<SiteList />} />
        <Route path='site-intelligence/web-content/:id' element={<WebContentDetail />} />
        <Route path='site-intelligence/sexual-content/:id' element={<SexualContentDetail />} />
        <Route path='site-intelligence/tobacco-content/:id' element={<TobaccoContentDetail />} />
        <Route path='site-intelligence/high-risk-ip/:id' element={<HighRiskIpDetail />} />
        <Route path='site-intelligence/disposable-email/:id' element={<DisposableEmailDetail />} />
        <Route path='site-intelligence/inbound-flow/:id' element={<InboundFlowDetail />} />
        <Route path='site-intelligence/outbound-flow/:id' element={<OutBoundFlowDetail />} />
        <Route path='site-intelligence/social-media-flow/:id' element={<SocialMediaFlowDetail />} />
        <Route path='site-intelligence/domain-info/:id' element={<DomainInfoDetail />} />
        <Route path='site-intelligence/customer-dispute/:id' element={<CustomerDisputeDetail />} />
        <Route path='site-intelligence/brand-detection/:id' element={<BrandDetectionDetail />} />
        <Route path='site-intelligence/related-identity/:id' element={<RelatedIdentityDetail />} />
        <Route path='site-intelligence/members-only/:id' element={<MembersOnlyDetail />} />
        <Route path='site-intelligence/category/:id' element={<CategoryDetail />} /> */}

        <Route path='site-inspect/reports/list' element={<SiList />} />
        <Route path='site-inspect/reports/:id' element={<SiDetail />} />

        {/* <Route path='site-inspect/company-info-related/list' element={<SiBySiteList />} />
        <Route path='site-inspect/company-info-related/:id' element={<SiDetail bySite />} /> */}

        {/* <Route path='site-inspect/keywords/list' element={<KeywordList />} />
        <Route path='site-inspect/keywords/extracted/list' element={<KeywordExtractionList />} /> */}

        {/* <Route path='site-inspect/brands/list' element={<BrandList />} /> */}

        <Route path='site-inspect/schedules/list' element={<ScheduleList />} />
        <Route path='site-inspect/schedules/form' element={<ScheduleCreateForm />} />

        <Route path='site-inspect/clients/list' element={<SiClientList />} />
        <Route path='site-inspect/clients/:id' element={<SiClientDetail />} />

        <Route path='site-inspect/remarks/list' element={<RemarkOptionList />} />

        <Route path='site-inspect/reviews/list' element={<SiReviewList />} />
        <Route path='site-inspect/reviews/history/list' element={<SiReviewHistoryList />} />

        {/* TLD */}
        <Route path='tld/sites/list' element={<TldSitesList />} />
        <Route path='tld/sites/form' element={<TldSitesCreateForm />} />
        <Route path='tld/sites/delete' element={<TldSitesDeleteForm />} />
        <Route path='tld/reports/list' element={<TldReportsList />} />
        {/* <Route path='tld/transactions/list' element={<TldTransactionsList />} />
        <Route path='tld/transactions/:id' element={<TldTransactionsDetail />} /> */}
        {/* <Route path='tld/clients/list' element={<TldClientList />} />
        <Route path='tld/clients/:merchant_id' element={<TldClientDetail />} /> */}
        {/* <Route path='tld/quotas/list' element={<TldQuotasList />} /> */}
        {/* <Route path='tld/remarks/list' element={<TldRemarkOptionsList />} /> */}
        {/* <Route path='tld/reviews/list' element={<TldReviewsList />} />
        <Route path='tld/review-reports/list' element={<TldReviewReportsList />} /> */}
        {/* <Route path='tld/audit-logs/list' element={<TldAuditLogsList />} /> */}

        {/* CDRN */}
        <Route path='cdrn/clients/list' element={<CdrnClientList />} />
        <Route path='cdrn/clients/:id' element={<CdrnClientDetail />} />
        <Route path='cdrn/descriptors/list' element={<CdrnDescriptorList />} />
        <Route path='cdrn/cases/list' element={<CdrnCaseList />} />
        <Route path='cdrn/cases/list' element={<CdrnCaseList />} />
        <Route path='cdrn/cases/:id' element={<CdrnCaseDetail />} />

        {/* Subscription */}
        <Route path='contact-us' element={<ContactUs />} />

        {/* Dashboard */}
        {/* <Route path='dashboard' element={<Dashboard />} /> */}

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

export { PrivateRoutes };
